import React from "react";
import classes from "./PageHeaderName.module.css";

export default function PageHeaderName({ title }) {
  return (
    <div className={classes.headerContainer}>
      <h1 className={classes.headerBox}>{title}</h1>
    </div>
  );
}
